<script>
import ErrorReporter from './js-error-reporter';

export default {
  props: {
    reporter: {
      type   : ErrorReporter,
      default: () => new ErrorReporter(),
    },
  },
  methods: {
    report(message, error) {
      this.reporter.report(message, error);
    },
  },
};
</script>
